export function groupExpectations(expectations) {
  const coming = [];
  const notComing = [];
  const pending = [];
  for (const row of expectations || []) {
    if (row.status === "coming") coming.push(row);
    else if (row.status === "not_coming") notComing.push(row);
    else pending.push(row);
  }
  return { coming, notComing, pending };
}

export function expectationBadge(status) {
  if (status === "coming") return { label: "Придёт", tone: "coming" };
  if (status === "not_coming") return { label: "Не придёт", tone: "not" };
  if (status === "unknown") return { label: "Не знаю", tone: "unknown" };
  return { label: "Нет ответа", tone: "none" };
}

export function findExpectation(expectations, patientId) {
  return (expectations || []).find((e) => e.patient_id === patientId);
}
